<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
export default {
	props: {
		HuanqInvoicePreview: {
			type: Boolean,
			default: false
		}
	},
	watch: {
		HuanqInvoicePreview: function(indexVal, oldVal) {
			if (indexVal) {
			}
		}
	},
	data() {
		return {};
	},
	mounted() {},
	created() {},
	methods: {
		closediagInvoicePreview() {
			this.$emit('closediagInvoicePreview', false);
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
